import useStore from './useStore';
import { StoreContext } from '../stores';
import type createAppStore from '../stores/appStore';

type AppStore = ReturnType<typeof createAppStore>;

const useAppStore = <Selected = AppStore>(dataSelector: (store: AppStore) => Selected = (store) => store as unknown as Selected) =>
  useStore(StoreContext, (value) => (value as { appStore: AppStore }).appStore, dataSelector);

export default useAppStore;
